import React from 'react';
import createForm from "./Form";
import Tabs from "../../layout/Tabs";
import TabContent from "../../layout/TabContent";
import Select from "../../form/Select";
import TextInput from "../../form/TextInput";
import TextArea from "../../form/TextArea";

class MoneyTransferDocumentForm extends React.Component {

    getFieldProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        if (this.props.values[this.props.componentConfig.idfield]) {
            props.disabled = true;
        }
        return props;
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select
                            label="Pénztár"
                            name="moneyrepository"
                            component="MoneyRepository"
                            filter={[
                                {
                                    field: "component_type",
                                    value: "CashRepository"
                                },
                                ...((((this.props.till || {}).pos || {}).location || {}).id ? [{
                                    field: "location",
                                    value: (((this.props.till || {}).pos || {}).location || {}).id
                                }] : [{
                                    field: "location.partner",
                                    value: (((this.props.till || {}).pos || {}).partner || {}).partner_id
                                }])
                            ]}
                            objectValue={true}
                            labelKey="name"
                            storeType="local"
                            {...this.getFieldProps("moneyrepository")}
                            value={this.props.values.moneyrepository}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                {this.props.values.moneyrepository && <Tabs
                    theme="default"
                    currentTab={this.props.values.direction}
                    {...this.getFieldProps("direction")}
                    onTabChange={(tabName) => this.props.setFieldValue("direction", tabName)}
                >
                    <TabContent tabLabel="Kivétel" tabName={"-1"}>
                        <div className="row form-row">
                            <div className="col-md-6">
                                <TextInput type="number"
                                   name="amount"
                                   label={"Összeg"}
                                   value={this.props.values.amount}
                                   {...this.getFieldProps("amount")}
                                   saveChanges={this.props.setFieldValue}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextInput type="text"
                                   name="partner_name"
                                   label={"Kedvezményezett"}
                                   value={this.props.values.partner_name}
                                   {...this.getFieldProps("partner_name")}
                                   saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                        <div className="row form-row">
                            <div className="col-md-12">
                                <TextArea
                                    {...this.getFieldProps("comment.text")}
                                    name="comment.text"
                                    value={(this.props.values.comment || {}).text}
                                    label="Megjegyzés"
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </TabContent>
                    <TabContent tabLabel="Betétel" tabName={"1"}>
                        <div className="row form-row">
                            <div className="col-md-6">
                                <TextInput type="number"
                                   name="amount"
                                   label={"Összeg"}
                                   value={this.props.values.amount}
                                   {...this.getFieldProps("amount")}
                                   saveChanges={this.props.setFieldValue}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextInput type="text"
                                   name="partner_name"
                                   label={"Befizető"}
                                   value={this.props.values.partner_name}
                                   {...this.getFieldProps("partner_name")}
                                   saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                        <div className="row form-row">
                            <div className="col-md-12">
                                <TextArea
                                    {...this.getFieldProps("comment.text")}
                                    name="comment.text"
                                    value={(this.props.values.comment || {}).text}
                                    label="Megjegyzés"
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </TabContent>
                    <TabContent tabLabel="Áthelyezés" tabName={"0"}>
                        <div className="row form-row">
                            <div className="col-md-6">
                                <TextInput type="number"
                                   name="amount"
                                   label={"Összeg"}
                                   value={this.props.values.amount}
                                   {...this.getFieldProps("amount")}
                                   saveChanges={this.props.setFieldValue}
                                />
                            </div>
                            <div className="col-md-6">
                                <Select
                                    label="Pénztár"
                                    name="moneyrepository_to"
                                    component="MoneyRepository"
                                    filter={[
                                        {
                                            field: "component_type",
                                            value: "CashRepository"
                                        }
                                    ]}
                                    objectValue={true}
                                    labelKey="name"
                                    valueKey="repository_id"
                                    storeType="local"
                                    {...this.getFieldProps("moneyrepository_to")}
                                    value={this.props.values.moneyrepository_to}
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                        <div className="row form-row">
                            <div className="col-md-12">
                                <TextArea
                                    {...this.getFieldProps("comment.text")}
                                    name="comment.text"
                                    value={(this.props.values.comment || {}).text}
                                    label="Megjegyzés"
                                    saveChanges={this.props.setFieldValue}
                                />
                            </div>
                        </div>
                    </TabContent>
                </Tabs>}
            </form>
        );
    }
}

export default createForm(MoneyTransferDocumentForm);
